import * as angular from "angular";

export class DivisionService {
    private $http: any;
    private readonly root: string;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.root = "/v2/division";
    }

    all(): Promise<object> {
        return this.$http.get(this.root + "/all");
    }

    divisionCampaigns(): Promise<object> {
        return this.$http.get(this.root + "/divisionCampaigns");
    }

    getDivisionUsers(data: any): Promise<object> {
        return this.$http.get(this.root + "/getDivisionUsers/" + data.id);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.root + "/create", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.root + "/update/" + data.id, data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.root + "/delete/" + data.id, data);
    }

    updateOrder(data: any): Promise<object> {
        return this.$http.post(this.root + "/updateOrder", data);
    }

    updateCampaignsOrder(data: any): Promise<object> {
        return this.$http.post(this.root + "/updateCampaignsOrder", data);
    }
}

angular.module("vcServices").service("DivisionService", DivisionService);
